import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppSessionService } from '../app-session/app-session.service';
import { Observable, throwError } from 'rxjs';
import { setAdvancedFilterQuery, setSimpleFilterQuery } from '../../utils/tableUtils';
import { FilterOperation } from 'src/app/models/custom-table/custom-table.model';
import { SequencePhaseDTO } from 'src/app/models/playlists/sequenceDTO';
import { TerminalType } from 'src/app/models/playlists/playlistDTO';
import { catchError, map } from 'rxjs/operators';
import { NormalizedSequencesPerPhase } from 'src/app/layout-modules/playlists-Management/playlist-detail/playlist-detail.component';

@Injectable({
  providedIn: 'root'
})
export class PlaylistsService {

  constructor(
    private http:HttpClient,
    private appSessionService: AppSessionService
  ) {  }

  private BASE_URL = this.appSessionService.baseUrl + "/api/v1/multimedia/playlists"

  getPlaylists(
    paging?: any,
    filteringArgs?: any,
    sortingArgs?: any, 
    advancedFilteringArgs?: any
  ): Observable<any>{
    const headers = this.setHeaders(filteringArgs, sortingArgs, advancedFilteringArgs);

    return this.http.get<any>(this.BASE_URL+`?${this._buildScrollExpression(paging)}`, {headers})
  }

  getPlaylist(token: string): Observable<any> {
    return this.http.get<any>(
      `${this.BASE_URL}/${token}`, 
      {headers: {"content-type": "application/json"}}
    );
  }

  createPlaylist(playlist: {
    name: string;
    terminalType: TerminalType;
    sequencesPerPhase: NormalizedSequencesPerPhase;
  }): Observable<any> {

    const headers = new HttpHeaders({
      "Content-type": "application/json",
    });

    const data = JSON.stringify(playlist);
    return this.http.post<any>(this.BASE_URL, data, {headers}).pipe(
      map(({ result }) => result),
      catchError(error => throwError(error))
    );
  }

  updatePlaylist(playlist: {
    name: string;
    terminalType: TerminalType;
    sequencesPerPhase: NormalizedSequencesPerPhase;
  },
  id: string
  ): Observable<any> {

    const headers = new HttpHeaders({
      "Content-type": "application/json",
    });

    const data = JSON.stringify(playlist);
    const url = `${this.BASE_URL}/${id}`;
    return this.http.put<any>(url, data, { headers }).pipe(
      map(({ result }) => result),
      catchError(error => throwError(error))
    );
  }

  deletePlaylist(id: string): Observable<any> {
    const headers = new HttpHeaders({
      "Content-type": "application/json",
    });

    const url = `${this.BASE_URL}/${id}`;
    return this.http.delete(url, { headers }).pipe(
      catchError((error) => throwError(error))
    );
  }

  getSequencesList(
    paging?: any,
    filteringArgs?: any,
    sortingArgs?: any, 
    advancedFilteringArgs?: any
  ): Observable<any>{
    const headers = this.setHeaders(filteringArgs, sortingArgs, advancedFilteringArgs);

    return this.http.get<any>(
      this.appSessionService.baseUrl + `/api/v1/multimedia/sequences?${this._buildScrollExpression(paging)}`, {headers}
    )
  }

  getSequence(token: string): Observable<any> {
    let headers = new HttpHeaders({
        "Content-type": "application/json",
      });
    const url = `${this.appSessionService.baseUrl}/api/v1/multimedia/sequences/${token}`;
    
    return this.http.get<any>(url, { headers }).pipe(
      map(({ result }) => result),
      catchError(error => throwError(error))
    );
  }

  setHeaders(
      filteringArgs?: any,
      sortingArgs?: any,
      advancedFilteringArgs?: any
    ) {
      let headers = new HttpHeaders({
        "Content-type": "application/json",
      });
  
      let filterQuery = "";
      let advancedFilterQuery = "";
      let orderQuery = "";
  
      if (filteringArgs) {
        filterQuery = setSimpleFilterQuery(filteringArgs);
      }
  
      if (advancedFilteringArgs) {
        advancedFilterQuery = setAdvancedFilterQuery(advancedFilteringArgs);
      }
  
      if (sortingArgs) {
        const { active, direction } = sortingArgs;
        orderQuery += active + "," + direction.toUpperCase();
      }
  
      if (filterQuery.length > 0 || advancedFilterQuery.length > 0) {
        headers = headers.append(
          "query",
          `${filterQuery} ${
            filterQuery.length > 0 && advancedFilterQuery.length > 0
              ? FilterOperation.AND
              : ""
          } ${advancedFilterQuery}`
        );
      }
  
      if (orderQuery.length > 0) {
        headers = headers.append("sort", orderQuery);
      }
  
      return headers;
    }

    private _buildScrollExpression(pagingArgs): string {
      const skip = pagingArgs?.skip;
      const top = pagingArgs?.top;
      const realSize = pagingArgs?.realSize;

      if (top && top !== null) {
        return `real_size=${!!realSize}&offset=${skip}&limit=${top}`;
      } else {
        return `real_size=${!!realSize}&offset=${skip}`;
      }
    }
}
